<div class="username__container" [ngClass]="activeClass" (click)="popover.toggle($event)">
  <span class="username__container--orgName">{{ organizationName }}</span> : <span class="username__container--loginName">{{ username }}</span>
</div>

<app-popover #popover [isPinned]="true" class="user-popup">
  <div class="menu__container">
    <!-- TODO: Create a Menu Item Component OR... Is there a shared copmonent -->
    <!-- TODO: Continued - Checkout primeng MegaMenu -->
    <div class="user-circle" [ngClass]="backgroundClass">
      <div class="circle-text">
        <span class="initial-name">{{ initialUserFirstName }}</span>
        <span class="initial-name">{{ initialUserLastName }}</span>
      </div>
    </div>
    <div class="menu__container--user-detail">
      <div class="username__container--orgName">{{ organizationName }}</div>
      <div class="username__container--loginName">{{ username }}</div>
    </div>
    <div class="menu__container--sign-out">
      <app-button class="sign-out-button"
                  text="SIGN OUT"
                  (onClick)="logout()">
      </app-button>
    </div>
  </div>
</app-popover>
